import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImages } from '@fortawesome/pro-light-svg-icons'

import styles from './styles.scss'

import Image from '../Image'

const ImageWithButton = (props) => {
  const { onClick, imageProps, text, url, placeholderUrl } = props

  return (
    <a className={styles.root} onClick={onClick}>
      <Image
        backgroundPosition="top center"
        height={200}
        placeholderUrl={placeholderUrl}
        url={url}
        width="100%"
        {...imageProps}
      />
      <>
        <span className={styles.changeText}>
          <FontAwesomeIcon icon={faImages} style={{ marginRight: 5 }} />
          {text || 'Manage Images'}
        </span>
      </>
    </a>
  )
}

ImageWithButton.propTypes = {
  callbacks: PropTypes.shape({
    onClick: PropTypes.func.isRequired,
  }),
  imageProps: PropTypes.object,
  placeholderUrl: PropTypes.string,
  text: PropTypes.string,
  url: PropTypes.string,
}

export default ImageWithButton
